import clsx from 'clsx'
import { tv } from 'tailwind-variants'

export const ICON_VARIANTS = tv({
  base: clsx('aria-disabled:tw-fill-gray-400'),
  variants: {
    size: {
      xs: clsx('tw-h-3 tw-w-3'), // 12px(1/2)
      sm: clsx('tw-h-[14px] tw-w-[14px]'), // 14px(7/12)
      md: clsx('tw-h-4 tw-w-4'), // 16px(2/3)
      lg: clsx('tw-h-[18px] tw-w-[18px]'), // 18px(9/12)
      xl: clsx('tw-h-5 tw-w-5'), // 20px(5/6)
      '2xl': clsx('tw-h-6 tw-w-6'), // 24px(1)
      '3xl': clsx('tw-h-7 tw-w-7'), // 28px(7/6)
      '4xl': clsx('tw-h-8 tw-w-8'), // 32px(4/3)
      '5xl': clsx('tw-h-9 tw-w-9'), // 36px(9/8)
      '6xl': clsx('tw-h-10 tw-w-10'), // 40px(5/4)
    },
    color: {
      primary: clsx('tw-fill-primary-500 tw-text-primary-500'),
      tertiary: clsx('tw-fill-accentBlue-500 tw-text-accentBlue-500'),
      alert: clsx('tw-fill-labelRed-500 tw-text-labelRed-500'),
      description: clsx('tw-fill-gray-600 tw-text-gray-600'),
      disabled: clsx('tw-fill-gray-400 tw-text-gray-400'),
      white: clsx('tw-fill-white tw-text-white'),
      success: clsx('tw-fill-green-600 tw-text-green-600'),
      warning: clsx('tw-fill-labelOrange-500 tw-text-labelOrange-500'),
      yellow: clsx('tw-fill-accentYellow-500 tw-text-accentYellow-500'),
      body: clsx('tw-fill-black tw-text-black'),
    },
  },
  defaultVariants: {
    color: 'primary',
  },
})
